//import './style.css' // removed
import { createApp, provide, h } from 'vue'
import PrimeVue from 'primevue/config';
import Nora from '@primeuix/themes/nora'
import Lara from '@primeuix/themes/lara'
import Aura from '@primeuix/themes/aura'
import ToastService from 'primevue/toastservice';
import ConfirmationService from 'primevue/confirmationservice'
import App from '@/App.vue'
import router from '@/router'
import { DefaultApolloClient } from '@vue/apollo-composable'
import { ApolloClient, HttpLink, concat, InMemoryCache, ApolloLink } from '@apollo/client/core'
import 'primeicons/primeicons.css' //Maybe there is a better way to do this import but this works.
import './assets/styles.css'
//import { ApolloLink, concat } from "apollo-link";
//import {  } from '@apollo/client';
//import { HttpLink } from 'apollo-link-http';
//import "bootstrap/dist/css/bootstrap.min.css";
//import "bootstrap";
import barkerAuth from '@/auth'
// HTTP connection to the API
//console.log(import.meta.env) //debug
const httpLink = new HttpLink({
  //uri: import.meta.env.VUE_APP_API_TARGET,
  uri: window.location.host.includes('localhost') ? 'http://localhost:8000/graphql' : 'https://nereus.tritonx.co/backend/graphql',
})

const authMiddleware = new ApolloLink((operation, forward) => {
  const token = barkerAuth.getToken()
  operation.setContext({
    headers:{
      authorization: token ? `Bearer ${token}`:'',
    },
  })
  return forward(operation);
})

const defaultClient = new ApolloClient({
  link: concat(authMiddleware, httpLink),
  cache: new InMemoryCache(),
})

const app = createApp({
  setup(){
    provide(DefaultApolloClient, defaultClient)
  },
  render(){
    return h(App)
  }
})

app.use(
    PrimeVue,{theme:{preset:Aura},}
  ).use(
    router
  ).use(
    ToastService
  ).use(
    ConfirmationService
  ).mount('#app')
